
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 15.998a16 16 0 1016-16 16 16 0 00-16 16z","fill":"#f7fafc"}}),_c('path',{attrs:{"d":"M28.72 14.749a.844.844 0 00-1.182.158l-3.244 4.251a.844.844 0 101.343 1.021l3.244-4.251a.844.844 0 00-.161-1.179zm-11.2 6.4L8.736 17.9a.843.843 0 00-.585 1.581l3.376 1.249-.745 1.315h-2.9v-1.19a.842.842 0 00-1.684 0v3.779a.842.842 0 001.684 0v-.9h3.389a.842.842 0 00.734-.428l1.122-1.98 3.806 1.409a.855.855 0 00.292.053.844.844 0 00.292-1.635zm9.6-9.275a2.321 2.321 0 00-1.458-1.559L11.481 5.208a2.343 2.343 0 00-3.023 1.484l-2 6.19a2.334 2.334 0 001.438 2.927l11.953 4.294a2.344 2.344 0 002.635-.758l4.231-5.377a2.326 2.326 0 00.413-2.089zm-14.849-.936a1.236 1.236 0 111.236-1.236 1.236 1.236 0 01-1.228 1.239z","fill":"#acaebe"}})])
          )
        }
      }
    